<template>
  <div class="main-table-wrapper">
    <el-table
      :data="data"
      width="100%">
      <el-table-column
        :label="$tc('tournament.tournament_name')"
        min-width="250px">
        <template slot-scope="scope">
          <router-link :to="{ name: 'TournamentView', params: { id: scope.row.id } }" class="link">
            {{ scope.row.name }}
          </router-link>
        </template>
      </el-table-column>

      <el-table-column
        :label="$tc('tournament.registration_start_date')"
        width="200px">
        <template slot-scope="scope">
          {{ scope.row.startDate | date('LLL') }}
        </template>
      </el-table-column>

      <el-table-column
        :label="$tc('tournament.registration_end_date')"
        width="200px">
        <template slot-scope="scope">
          <span v-if="scope.row.endDate">
            {{ scope.row.endDate | date('LLL') }}
          </span>
        </template>
      </el-table-column>

      <el-table-column
        :label="$tc('tournament.competitors', 2)"
        width="150px">
        <template slot-scope="scope">
          {{ scope.row.competitorsCount || 0 }}
        </template>
      </el-table-column>

      <el-table-column
        :label="$tc('tournament.teams')"
        width="100px">
        <template slot-scope="scope">
          {{ scope.row.clubsCount || 0 }}
        </template>
      </el-table-column>

      <el-table-column
        v-if="canEdit"
        :label="$tc('general.actions')"
        width="80px"
        align="right">
        <template slot-scope="scope">
          <el-dropdown trigger="click" @command="(command) => handleCommand(command, scope.row)">
            <el-button type="primary" icon="el-icon-more" circle />
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="edit"><i class="el-icon-edit" />{{ $tc('general.edit') }}</el-dropdown-item>
              <el-dropdown-item v-if="!scope.row.isArchived" :disabled="scope.row.isActive" command="archive"><i class="el-icon-takeaway-box" />{{ $tc('general.archive', 2) }}</el-dropdown-item>
              <el-dropdown-item command="delete"><i class="el-icon-delete" />{{ $tc('general.delete') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import errorHandler from '@/common/errorHandler.js'

export default {
  props: {
    data: {
      type: Array,
      default: null
    },

    canEdit: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    handleCommand (command, tournament) {
      if (command === 'edit') {
        this.$router.push({ name: 'EditTournament', params: { id: tournament.id } })
      } else if (command === 'archive') {
        this.askArchive(tournament)
      } else if (command === 'delete') {
        this.beforeDelete(tournament)
      }
    },

    async askArchive (tournament) {
      try {
        await this.$confirm(this.$tc('messages.ask_archive_tournament'))

        this.doArchive(tournament)
      } catch {}
    },

    async beforeDelete (tournament) {
      try {
        await this.$confirm(this.$tc('messages.ask_delete_tournament'))

        this.onDelete(tournament)
      } catch {}
    },

    async doArchive (tournament) {
      const loading = this.$loading()
      try {
        await this.$store.dispatch('tournaments/archive', tournament.id)
        this.$message.success(this.$tc('messages.success_archived_tournament'))
      } catch (e) {
        console.error(e)
        errorHandler(e)
      } finally {
        loading.close()
      }
    },

    async onDelete (tournament) {
      const loading = this.$loading()
      try {
        await this.$store.dispatch('tournaments/delete', tournament.id)
        this.$message.success(this.$tc('messages.success_deleted_tournament'))
      } catch (e) {
        console.error(e)
        errorHandler(e)
      } finally {
        loading.close()
      }
    }
  }
}
</script>
